<div *ngIf="city == 'sofia' || city == 'plovdiv' || city == 'varna'" id="blog" class="container-large">
    <div class="section-header">
        <h2 class="section-title">{{this.word[this.language].blog}} Zavedenia.bg</h2>
    </div>
    <div class="news-section-row">
        <div class="latest-news blog-wrap">
            <span class="blog-wrap-title-row">
                <h3>{{this.word[this.language].lastPosts}}</h3>
                <a title="{{this.word[this.language].interestingFromZavedenia}}"
                   [routerLink]="'/' + language == 'en'
                              ? language + '/1/Interesno-ot-zavedeniyata-i-Sofiya/news'
                              : '1/Interesno-ot-zavedeniyata-i-Sofiya/news'"
                    class="classic-link">{{this.word[this.language].seeAll}} ></a>
            </span>

            <div class="latest-news-list ">
                <div *ngFor="let new of news?.slice(0, 3)" class="latest-news-list-item">
                    <div class="latest-news-list-item-photo">
                        <img width="170" height="120" loading="lazy" class="latest-news-item-photo" src="{{new?.filename}}" alt="{{new?.label}}" onerror="this.src='../../../assets/images/news-image-placeholder.jpg'">
                    </div>
                    <div class="latest-news-preview">
                        <span class="blog-tags">
                            {{new?.dateCreated}}
                        </span>
                        <h4>
                            <a title="{{new?.label}}" class="classic-link"
                               [routerLink]="'/' + language == 'en'
                              ? language + '/' + new?.venueId + '/' + toLatin(new?.venueName) + '/news/' + new?.id + '/' + toLatin(new?.label)
                              : new?.venueId + '/' + toLatin(new?.venueName) + '/news/' + new?.id + '/' + toLatin(new?.label)">
                              {{new?.label}}
                            </a>
                        </h4>

                        <p class="short-preview" [innerHTML]="new?.description"></p>
                        <div class="bacchus-promo d-flex-row" *ngIf="new?.author == 'бакхус' || new?.author == 'Бакхус'">
                          <!-- <div class="bacchus-promo d-flex-row" > -->
                            <p>Съдържание на</p>
                            <a
                              href="/{{language == 'en' ? language + '/' + new?.link : new?.link}}"
                              target="_blank" rel="nofollow">
                              <img height="15" src="../../../../assets/images/bacchus.png" alt="Bacchus logo">
                            </a>
                          </div>
                          <div *ngIf="new?.author.indexOf('LocalGuideBG') >= 0" class="internal-post d-flex-center">
                            <p>Съдържание на </p>
                          <a href="https://localguidebg.com" rel="nofollow" target="_blank" class="localguide-promo-post d-flex-center">  <img height="23px" src="../../../../assets/images/localguidebg-logo.png" alt="localguide.bg pormotional banner">
                          </a>
                          </div>
                          <div *ngIf="new?.author.indexOf('booky') >= 0" class="internal-post d-flex-center">
                            <p>Вижте повече на:</p>
                            <a href="{{new?.link}}" rel="nofollow" target="_blank" class="d-flex-center">  <img height="19px" src="https://booky.bg/images2/bookylogo.png" alt="Booky.bg logo">
                            </a>
                          </div>
                          <div *ngIf="new?.author.indexOf('order') >= 0" class="internal-post d-flex-center">
                            <p>Вижте повече на:</p>
                            <a href="{{new?.link}}" rel="nofollow" target="_blank" class="d-flex-center">  <img height="19px" src="https://order.bg/resources/images/Logo.png" alt="order.bg logo">
                            </a>
                          </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="random-photo random-videos" *ngIf="afterPageLoaded">
          <!-- <div id="yt-video-1">
            https://img.youtube.com/vi/4ZE7mNy-YjA/hqdefault.jpg
          </div>
          <div id="yt-video-2">
            https://img.youtube.com/vi/wz_6SUl2ICo/hqdefault.jpg
          </div> -->
          <iframe src="" frameborder="0"
          width="100%"
          height="100%"
          srcdoc="<style>
            * {
              padding: 0;
              margin: 0;
              box-sizing: border-box;
              overflow: hidden;
            }
            body, html{
              height: 100%;
            }
            img, svg {
              position: absolute;
              width: 100%;
              top: 0;
              bottom: 0;
              margin: auto;
            }

            svg {
              filter: drop-shadow(1px 1px 10px hsl(206.5, 70.7%, 8%));
              transition: all 250ms ease-in-out;
            }

            body:hover svg {
              filter: drop-shadow(1px 1px 10px hsl(206.5, 0%, 10%));
              transform: scale(1.2);
            }
          </style>
          <a href='https://www.youtube.com/embed/4ZE7mNy-YjA?rel=0&enablejsapi=1&autoplay=1'>
            <img src='https://img.youtube.com/vi/4ZE7mNy-YjA/hqdefault.jpg' alt='Zav'>
            <svg xmlns='http://www.w3.org/2000/svg' width='64' height='64' viewBox='0 0 24 24' fill='none' stroke='#ffffff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-play-circle'><circle cx='12' cy='12' r='10'></circle><polygon points='10 8 16 12 10 16 10 8'></polygon></svg>
          </a>
           " title="Zav Video 1"></iframe>
          <iframe src="" frameborder="0"
          width="100%"
          height="100%"
          srcdoc="<style>
            * {
              padding: 0;
              margin: 0;
              box-sizing: border-box;
              overflow: hidden;
            }
            body, html{
              height: 100%;
            }
            img, svg {
              position: absolute;
              width: 100%;
              top: 0;
              bottom: 0;
              margin: auto;
            }

            svg {
              filter: drop-shadow(1px 1px 10px hsl(206.5, 70.7%, 8%));
              transition: all 250ms ease-in-out;
            }

            body:hover svg {
              filter: drop-shadow(1px 1px 10px hsl(206.5, 0%, 10%));
              transform: scale(1.2);
            }
          </style>
          <a href='https://www.youtube.com/embed/wz_6SUl2ICo?rel=0&enablejsapi=1&autoplay=1'>
            <img src='https://img.youtube.com/vi/wz_6SUl2ICo/hqdefault.jpg' alt='Zav'>
            <svg xmlns='http://www.w3.org/2000/svg' width='64' height='64' viewBox='0 0 24 24' fill='none' stroke='#ffffff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-play-circle'><circle cx='12' cy='12' r='10'></circle><polygon points='10 8 16 12 10 16 10 8'></polygon></svg>
          </a>
           " title="Zav Video 2"></iframe>
          <!-- <iframe
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/4ZE7mNy-YjA?si=LZx1odcMxHmKiYn4"
          title="Zavedenia Video"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen="true"
          loading="lazy"
        ></iframe> -->
          <!-- <iframe
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/wz_6SUl2ICo?si=Nr_9jlurnTgv4G8l"
          title="Zavedenia Video"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen="true"
          loading="lazy"
        ></iframe> -->
        <!-- https://www.youtube.com/embed/6G7Ucqj5Krc?si=Nr_9jlurnTgv4G8l -->
        </div>
        <div *ngIf="0" class="random-photo" style="background-image: url('https://zavedenia.com/_images/srw.jpg'); background-position: center;">

            <div class="photo-content">
                <div class="content-blur-bg">

                </div>
                <div class="photo-content-text">
                    <span>RESTAURANT WEEK</span>
                    <p>Пролет 2022</p>
                    <span>Очаквайте новото издание на Restaurant Week през пролетта.</span>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="false" class="news-section-row">
        <div class="most-viewed blog-wrap">
            <span class="blog-wrap-title-row">
                <h3>{{this.word[this.language].mostViewed}}</h3>
            </span>

            <div class="most-viewed-posts">
                <div class="most-viewed-article">
                    <div class="article-photo">
                        <!-- <img src="./resources/images/new-year.jpg" alt="Article Photo"> -->
                    </div>
                    <p class="article-titl">
                        A hugeass title
                    </p>

                    <p class="article-short">
                        It’s Chinese New Year this week, welcome to the year of the dog! We’ve taken a look at the 12
                        animals of the Chinese zodiac and suggested a tour for each.
                        , so read on to find your perfect trip!
                    </p>
                </div>
                <div class="most-viewed-article">
                    <div class="article-photo">
                        <!-- <img src="./resources/images/new-year.jpg" alt="Article Photo"> -->
                    </div>
                    <p class="article-titl">
                        A hugeass title
                    </p>

                    <p class="article-short">
                        It’s Chinese New Year this week, welcome to the year of the dog! We’ve taken a look at the 12
                        animals of the Chinese zodiac and suggested a tour for each.
                        , so read on to find your perfect trip!
                    </p>
                </div>

            </div>
        </div>
    </div>
    <div *ngIf="city == 'sofia'" class="news-section-row link-to-blog">
        <div class="link-to-blog-banner" style="background-image: url('assets/images/to-blog-bg.jpg');">
            <div class="banner-content">
                <p>{{this.word[this.language].seeOurBlog}}</p>
                <a [routerLink]="['/', '1', toLatin('Селекции заведения'), 'news']" class="btn-transparent-blur">{{this.word[this.language].seeMore}}</a>
            </div>
        </div>
    </div>
</div>
